import { render, staticRenderFns } from "./BannerApprovalAudit.vue?vue&type=template&id=f2186232"
import script from "./BannerApprovalAudit.vue?vue&type=script&lang=js"
export * from "./BannerApprovalAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports